import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Finance } from "../../../models/finance.model";
import Shop from "../../../models/shop.model";

@Component({
  selector: "ngx-layout-finance-a4",
  templateUrl: "layout-finance-a4.component.html",
  styleUrls: ["layout-finance-a4.component.scss"],
})
export class LayoutFinanceA4Component
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() finance?: Finance;
  @Input() shop?: Shop;
  @Input() isRefLanguage?: boolean = false;

  loading = false;
  printing = false;
  displayName = "";
  numToText = "";

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      console.log("LayoutFinanceA4Component:", this.finance);
    });
  }

  print() {
    this.printing = true;
  }
}
